<template>
    <div>
        <v-card flat class="pa-1">
            <v-toolbar flat color="#FFF" short>
                <v-toolbar-title>Listagem de Eventos</v-toolbar-title>
            </v-toolbar>
            <v-tabs centered>
                <v-tab>
                    <v-icon left>mdi-clipboard-list-outline</v-icon>
                    Eventos 
                </v-tab>
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <listaEventos></listaEventos>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>
<script>


import listaEventos from './ListaEventos'
export default {

    components: {
        listaEventos
    },

    data() {
        return {
            
        }
    },

    computed: {
        
    },

    watch: {
        
    },

    created() {

    },

    methods: {

    }
};
</script>
<style></style>
